import React from "react";
import "./sudanLanding.scss";
import { useLanguage } from "../i18n/LanguageContext";

const STATS = [
   { num: "11,900+", label: "NGOs & CSOs registered with the Humanitarian Aid Commission" },
   { num: "18", label: "States served by the KAPorg platform" },
   { num: "20", label: "Organizations selected per annual cohort" },
   { num: "Free", label: "Platform access for all national organizations" }
];

const StatsReset = () => {
   const { t } = useLanguage();
   return (
      <section className="sd-section sd-stats">
         <div className="container">
            <div className="sd-stats-grid">
               {STATS.map((stat) => (
                  <div className="sd-stat" key={stat.label}>
                     <div className="sd-stat-num">{t(stat.num)}</div>
                     <div className="sd-stat-label">{t(stat.label)}</div>
                  </div>
               ))}
            </div>

            <div className="sd-reset-callout centered">
               <div className="sd-reset-body">
                  <h3>{t("The humanitarian system is changing.")}</h3>
                  <p>
                     {t(
                        "In March 2025, the UN Emergency Relief Coordinator launched the Humanitarian Reset — a global commitment to shift power, funding, and decision-making to local and national actors. The IASC Roadmap sets an aspiration of 70% of pooled funding channelled directly to local organizations."
                     )}
                  </p>
                  <p>
                     {t(
                        "With 16.9 million displaced people in need of humanitarian assistance across Sudan, local organizations are on the frontlines. KAPorg exists to ensure Sudanese organizations are ready, recognized, and positioned to receive direct funding."
                     )}
                  </p>
               </div>
            </div>
         </div>
      </section>
   );
};

export default StatsReset;
